

export default function Footer() {

    return (
        <footer>Powered by LoyaltyNXT</footer>
    )
}